import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { baseApi } from "../services/base";
import globalReducer from "./slice/globalSlice";
import { rtkQueryErrorLogger } from "./middleware/rtkQueryErrorLogger";

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    global: globalReducer,
  },
  middleware: (getDefaultMiddleware) => [
    ...getDefaultMiddleware().concat(baseApi.middleware),
    rtkQueryErrorLogger,
  ],
});

setupListeners(store.dispatch);
